import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#fff',
    },
    background: {
      default: '#757575',
    },
    text: {
      primary: '#fff',
    },
    action: {
      active: '#fff',
    },
  },
});

export default theme;
